module.exports = __webpack_public_path__ + "static/media/convert-it-all.e1a88463.gif";